import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import ModalRegistrarCliente from '../../components/ModalRegistrarCliente';
import CustomModal from '../../components/CustomModal';
import useCustomModal from '../../hooks/useCustomModal';
import FormularioIniciarTramiteRTI from '../../components/RTI/FormularioIniciarTramiteRTI';
import FormularioIniciarTramiteART from '../ART/FormularioIniciarTramiteART';
import FormularioIniciarTramiteJubilacion from '../../components/Jubilacion/FormularioIniciarTramiteJubilacion';
import FormularioIniciarTramitePuam from '../../components/Puam/FormularioIniciarTramitePuam';
import FormularioIniciarTramitePlanPago from '../../components/PlanPago/FormularioIniciarTramitePlanPago';
import FormularioIniciarTramiteReajuste from '../../components/Reajuste/FormularioIniciarTramiteReajuste';
import FormularioIniciarTramiteReconocimiento from '../../components/Reconocimiento/FormularioIniciarTramiteReconocimiento';
import FormularioIniciarTramitePnc from '../../components/Pnc/FormularioIniciarTramitePnc';
import FormularioIniciarTramiteAmparoPnc, { VARIANTE_LEY_16986 } from '../../components/AmparoPnc/FormularioIniciarTramiteAmparoPnc';
import FormularioIniciarTramitePension from '../../components/Pension/FormularioIniciarTramitePension';
import FormularioIniciarTramiteGanancias from '../../components/Ganancias/FormularioIniciarTramiteGanancias';
import FormularioIniciarTramiteMinusvalia from '../../components/Minusvalia/FormularioIniciarTramiteMinusvalia';
import FormularioIniciarTramiteDeclaratoria from '../../components/Declaratoria/FormularioIniciarTramiteDeclaratoria';
import FormularioIniciarTramiteAmparo from '../../components/Amparo/FormularioIniciarTramiteAmparo';
import FormularioIniciarTramiteGenerico from '../../components/Generico/FormularioIniciarTramiteGenerico';
import VistaDetalladaAtencionAperturaPlan from './VistaDetalladaAtencionAperturaPlan';
import BotonGenerarCaratula from '../../components/Caratula/BotonGenerarCaratula';
import caratulaRegistry from '../../components/Caratula/base/caratulaRegistry';
import { useAuth } from '../../auth/AuthContext';
import { etiquetaResultadoAtencion } from '../../constants/resultadosAtencion';
import VistaDetalladaAtencionCobro from './VistaDetalladaAtencionCobro';
import { cambiarEstado, obtenerTurno, listarRango, actualizarCarpetaTurno, guardarBorradorAtencion, vincularClienteTurno } from '../../services/turneroService';
import { obtenerResumenAportesCliente } from '../../services/historialLaboralService';
import { resolverFirmaTurnoAnses } from '../../services/turnoAnsesService';
import { buscarClientes, getClientePorCuil } from '../../services/clienteService';
import { getTramites } from '../../services/tramiteService';
import DatosMaestrosService from '../../services/datosMaestrosService';
import HistorialTurnosCliente from '../../components/recepcion/HistorialTurnosCliente';
import VolverAContactarEnUnRenglon, { avisarDesdeParaPlazo } from '../../components/recepcion/VolverAContactarEnUnRenglon';
import { agregarAVolverAContactar, mensajeDeError } from '../../services/volverAContactarService';
import VincularClienteTurno, { LEYENDA_CRITERIO } from '../../components/recepcion/VincularClienteTurno';
import '../../style/pages/HomePage.css';
import '../../style/pages/VistaDetalladaAtencion.css';

import { apellidoNombre } from '../../utils/nombrePersona';
import { esTramiteActivo } from '../../utils/estadoTramite';
import { normalizarParaComparar } from '../../utils/textoComparable';
import { CampoDato, SelectorCatalogoConAlta, formatearFecha, formatearFechaHora, formatearHorario, formatearTipoTramite } from './atencionUi';
import { formatearMesAnio } from '../../utils/fechaLiquidar';
function formatearDuracion(inicio, fin) {
    if (!inicio || !fin) return '-';
    const inicioMs = new Date(inicio).getTime();
    const finMs = new Date(fin).getTime();
    if (Number.isNaN(inicioMs) || Number.isNaN(finMs) || finMs < inicioMs) return '-';
    const totalMinutos = Math.round((finMs - inicioMs) / 60000);
    const horas = Math.floor(totalMinutos / 60);
    const minutos = totalMinutos % 60;
    if (horas > 0) return `${horas} h ${minutos} min`;
    return `${minutos} min`;
}


// Motivo de no avance y Resultado de la atención son los dos catálogos editables desde
// Administración > Datos Maestros (ver GestionMotivosRechazo y GestionResultadosAtencion).
// Los dos se cargan dinámicamente en el componente (motivosRechazo / resultadosAtencion) y en
// los dos el nombre elegido ES el valor que se guarda tal cual en el turno, sin traducción
// código→label. Resultado dejó de ser un enum fijo en la migración V224.
// Los dos campos se dejan vacíos con la "x" del combo: vacío = sin especificar / sin
// clasificar, que es como lo guarda el turno (null) y como lo leen los reportes.

function normalizarEstado(estado) {
    const valor = String(estado || '').trim();
    if (!valor) return '';
    const sinAcentos = valor
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace('-', ' ')
        .toUpperCase();

    if (sinAcentos === 'EN CURSO') return 'EN_CURSO';
    if (sinAcentos === 'EN ANSES') return 'EN_ANSES';
    if (sinAcentos === 'FINALIZADO') return 'FINALIZADO';
    if (sinAcentos === 'ASISTIO') return 'ASISTIO';
    if (sinAcentos === 'NO ASISTIO') return 'NO_ASISTIO';
    return valor.toUpperCase();
}

function etiquetaEstado(estado) {
    switch (normalizarEstado(estado)) {
        case 'EN_CURSO':
            return 'En curso';
        case 'EN_ANSES':
            return 'En ANSES';
        case 'FINALIZADO':
            return 'Finalizado';
        case 'ASISTIO':
            return 'Asistió';
        case 'NO_ASISTIO':
            return 'No asistió';
        default:
            return estado || 'Sin estado';
    }
}

function resolverIdTurno(turno) {
    return turno?.idTurno ?? turno?.id ?? turno?.id_turno;
}

async function resolverClienteAsociadoTurno(turno) {
    if (!turno) return null;

    // Camino rápido (V222): si el turno ya sabe de qué cliente es, no hay nada que adivinar.
    // Lo de abajo es la heurística vieja, que sigue viva para los turnos que el matcher no
    // llegó a vincular (los anteriores a la migración, o los que quedaron en duda).
    if (turno.cuilCliente) {
        try {
            const cliente = await getClientePorCuil(turno.cuilCliente);
            if (cliente) return cliente;
        } catch (e) {
            // Si la ficha ya no existe se sigue con la heurística, como antes.
        }
    }

    const criterios = [];
    if (turno.cuil) criterios.push(String(turno.cuil));
    if (turno.dni) criterios.push(String(turno.dni));
    // Para BUSCAR va con espacio y no con apellidoNombre(): la coma de "APELLIDO, NOMBRE" viajaba
    // al buscador como parte del token y ningún cliente matcheaba.
    const nombreCompleto = [turno.apellido, turno.nombre].filter(Boolean).join(' ').trim();
    if (nombreCompleto) criterios.push(nombreCompleto);

    for (const criterio of criterios) {
        try {
            const valorNormalizado = String(criterio).replace(/\D/g, '');
            if (valorNormalizado.length === 11) {
                const cliente = await getClientePorCuil(String(criterio));
                if (cliente) return cliente;
            }
        } catch (error) {
            // Se intenta con el siguiente criterio si el cliente no existe.
        }
    }

    const criterioBusqueda = criterios.find((criterio) => Boolean(criterio)) || '';
    if (!criterioBusqueda) return null;

    try {
        const resultados = await buscarClientes(criterioBusqueda);
        const clientes = Array.isArray(resultados) ? resultados : [];
        const nombreTurno = [turno.apellido, turno.nombre].filter(Boolean).join(' ').trim().toLowerCase();
        const exacto = clientes.find((cliente) => {
            const cuilCliente = String(cliente?.cuil || '').replace(/\D/g, '');
            const dniCliente = String(cliente?.dni || '').replace(/\D/g, '');
            const cuilTurno = String(turno?.cuil || '').replace(/\D/g, '');
            const dniTurno = String(turno?.dni || '').replace(/\D/g, '');
            const nombreCliente = [cliente?.apellido, cliente?.nombre].filter(Boolean).join(' ').trim().toLowerCase();
            return (cuilCliente && cuilCliente === cuilTurno) || (dniCliente && dniCliente === dniTurno) || (nombreCliente && nombreCliente === nombreTurno);
        });
        return exacto || clientes[0] || null;
    } catch (error) {
        return null;
    }
}

// ============================================
// TRÁMITES QUE SE PUEDEN INICIAR DESDE LA FICHA
// ============================================

const TRAMITES_CONFIG = {
    RTI: {
        nombreCorto: 'RTI',
        ruta: '/rti/tramites',
        icono: 'bi-file-earmark-text',
        className: 'atencion-btn-rti',
        componente: FormularioIniciarTramiteRTI
    },
    ART: {
        nombreCorto: 'ART',
        ruta: '/art/tramites',
        icono: 'bi-file-earmark-medical',
        className: 'atencion-btn-art',
        componente: FormularioIniciarTramiteART
    },
    JUBILACION: {
        nombreCorto: 'Jubilación',
        ruta: '/jubilacion/tramites',
        icono: 'bi-file-earmark-richtext',
        className: 'atencion-btn-jubilacion',
        componente: FormularioIniciarTramiteJubilacion
    },
    PUAM: {
        nombreCorto: 'PUAM',
        ruta: '/puam/tramites',
        icono: 'bi-person-vcard',
        className: 'atencion-btn-puam',
        componente: FormularioIniciarTramitePuam
    },
    PLAN_PAGO: {
        nombreCorto: 'Plan de Pago 27.705',
        ruta: '/plan-pago/tramites',
        icono: 'bi-cash-coin',
        className: 'atencion-btn-planpago',
        componente: FormularioIniciarTramitePlanPago
    },
    REAJUSTE: {
        nombreCorto: 'Reajuste de Haberes',
        ruta: '/reajuste/tramites',
        icono: 'bi-graph-up-arrow',
        className: 'atencion-btn-reajuste',
        componente: FormularioIniciarTramiteReajuste
    },
    RECONOCIMIENTO: {
        nombreCorto: 'Reconocimiento de Servicios',
        ruta: '/reconocimiento/tramites',
        icono: 'bi-award-fill',
        className: 'atencion-btn-reconocimiento',
        componente: FormularioIniciarTramiteReconocimiento
    },
    PNC: {
        nombreCorto: 'PNC',
        ruta: '/pnc/tramites',
        icono: 'bi-person-lines-fill',
        className: 'atencion-btn-pnc',
        componente: FormularioIniciarTramitePnc
    },
    AMPARO_PNC: {
        nombreCorto: 'Amparo PNC',
        ruta: '/amparo-pnc/tramites',
        icono: 'bi-shield-exclamation',
        className: 'atencion-btn-amparopnc',
        componente: FormularioIniciarTramiteAmparoPnc
    },
    // Variante de Amparo PNC (V256): mismo formulario, nace con su propio tipo de trámite.
    AMPARO_LEY_16986: {
        nombreCorto: 'Amparo Ley 16.986',
        ruta: '/amparo-ley-16986/tramites',
        icono: 'bi-shield-exclamation',
        className: 'atencion-btn-amparopnc',
        componente: FormularioIniciarTramiteAmparoLey16986
    },
    PENSION: {
        nombreCorto: 'Pensión',
        ruta: '/pension/tramites',
        icono: 'bi-people',
        className: 'atencion-btn-pension',
        componente: FormularioIniciarTramitePension
    },
    GANANCIAS: {
        nombreCorto: 'Ganancias',
        ruta: '/ganancias/tramites',
        icono: 'bi-percent',
        className: 'atencion-btn-ganancias',
        componente: FormularioIniciarTramiteGanancias
    },
    MINUSVALIA: {
        nombreCorto: 'Minusvalía',
        ruta: '/minusvalia/tramites',
        icono: 'bi-person-wheelchair',
        className: 'atencion-btn-minusvalia',
        componente: FormularioIniciarTramiteMinusvalia
    },
    DECLARATORIA_HEREDEROS: {
        nombreCorto: 'Declaratoria',
        ruta: '/declaratoria/tramites',
        icono: 'bi-diagram-3',
        className: 'atencion-btn-declaratoria',
        componente: FormularioIniciarTramiteDeclaratoria
    },
    // Amparo por mora ante ANSES (V239). La clave es 'AMPARO' a secas: 'AMPARO_PNC' es el otro.
    AMPARO: {
        nombreCorto: 'Amparo por mora',
        ruta: '/amparo/tramites',
        icono: 'bi-shield-exclamation',
        className: 'atencion-btn-amparo',
        componente: FormularioIniciarTramiteAmparo
    }
};

// "Otro trámite…" (GENERICO) va aparte de TRAMITES_CONFIG porque no tiene botón propio en la
// grilla ni carátula, pero se abre en el mismo modal: antes navegaba a la pantalla de alta, se
// salía de la atención y el trámite nacía sin turno de origen (no contaba en la conversión).
function FormularioIniciarTramiteAmparoLey16986(props) {
    return <FormularioIniciarTramiteAmparoPnc {...props} variante={VARIANTE_LEY_16986} />;
}

const TRAMITE_GENERICO = { nombreCorto: 'Otro trámite', componente: FormularioIniciarTramiteGenerico };

const configTramite = (tipo) => (tipo === 'GENERICO' ? TRAMITE_GENERICO : TRAMITES_CONFIG[tipo]);

// Resultado que queda solo cuando en la atención se abrió un trámite y el operador no eligió nada.
// Se busca en el catálogo por nombre normalizado (V224 sembró "Inicia ahora").
const RESULTADO_INICIA_AHORA = 'Inicia ahora';
// "Carpeta a futuro" = en la atención se abrió un trámite con fecha de liquidar (queda esperando ese mes).
// Inicia ahora + Carpeta a futuro son las atenciones en las que se abrió un trámite (decisión 28-sep-2026).
const RESULTADO_CARPETA_A_FUTURO = 'Carpeta a futuro';
// Los desenlaces sin trámite: piden motivo de no avance. "No quiso dejar carpeta" (V255) separa en las
// estadísticas el caso viable que se perdió del que no daba; el motivo sale del mismo catálogo.
const RESULTADO_NO_VIABLE = 'No viable';
const RESULTADO_NO_QUISO_DEJAR_CARPETA = 'No quiso dejar carpeta';
const esResultado = (valor, nombre) => normalizarParaComparar(valor) === normalizarParaComparar(nombre);
const esResultadoSinTramite = (valor) => esResultado(valor, RESULTADO_NO_VIABLE) || esResultado(valor, RESULTADO_NO_QUISO_DEJAR_CARPETA);

const TRAMITES_PREVISIONALES_FIJOS = ['PUAM', 'PLAN_PAGO', 'REAJUSTE', 'RECONOCIMIENTO'];
const TRAMITES_ADICIONALES_FIJOS = ['PNC', 'AMPARO_PNC', 'AMPARO_LEY_16986', 'AMPARO', 'PENSION', 'GANANCIAS', 'MINUSVALIA', 'DECLARATORIA_HEREDEROS'];

function resolverOrdenTramitesPorTipo(tipoTramite) {
    const tipoUpper = String(tipoTramite || '').trim().toUpperCase();
    const principales = {
        JUBILACION: ['JUBILACION', 'RTI', 'ART'],
        ART: ['ART', 'RTI', 'JUBILACION'],
        RTI: ['RTI', 'ART', 'JUBILACION']
    };
    return principales[tipoUpper] || ['RTI', 'ART', 'JUBILACION'];
}

// La tabla tipotramite tiene 'Jubilación' (seed V2__seed_catalogos.sql) y 'JUBILACION' (seed
// V111__modulo_jubilacion.sql) conviviendo: hay que comparar sin acentos y con guion bajo para
// que ambos caigan en la misma clave de TRAMITES_CONFIG.
function normalizarTipoTramite(valor) {
    return String(valor || '')
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .trim().toUpperCase().replace(/\s+/g, '_');
}


const VistaDetalladaAtencion = ({ idTurnoProp, enModal, onCerrarModal }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { nroTurno } = useParams();
    const idTurnoEval = idTurnoProp || nroTurno;
    const { user, puede } = useAuth();

    // A dónde vuelve la ficha. Por defecto a Atención, pero si se abrió desde otra pantalla (un
    // listado) esa pantalla lo dice en el state de la navegación, y el botón vuelve ahí: si no,
    // tocar "Volver" desde el listado te dejaba en Atención y había que buscar el listado de nuevo.
    const volverA = location.state?.volverA;
    const etiquetaVolver = volverA?.texto || 'Volver a Atención';
    const handleSalir = () => {
        if (enModal && onCerrarModal) {
            onCerrarModal();
        } else if (volverA?.ruta) {
            navigate(volverA.ruta);
        } else {
            navigate('/recepcion/atencion');
        }
    };
    const { modalState, hideModal, showWarning, showConfirm } = useCustomModal();
    const turnoInicial = location.state?.turno;
    const [turno, setTurno] = useState(turnoInicial || null);
    const [cargando, setCargando] = useState(true);
    const [guardando, setGuardando] = useState(false);
    const [error, setError] = useState('');
    const [notas, setNotas] = useState('');
    const [motivoNoAvance, setMotivoNoAvance] = useState('');
    const [observacionMotivoNoAvance, setObservacionMotivoNoAvance] = useState('');
    const [resultadoAtencion, setResultadoAtencion] = useState('');
    // Listado "Volver a contactar" (V261): la casilla nace SIEMPRE destildada — el operador decide
    // caso por caso, no se sugiere por motivo. No va al borrador del servidor: es una decisión del
    // cierre, se aplica recién después de finalizar. Sin nota propia: en el listado se lee la
    // observación del motivo de no avance.
    const [agregarVolverAContactar, setAgregarVolverAContactar] = useState(false);
    const [mesesVolverAContactar, setMesesVolverAContactar] = useState(0);
    const [tieneCarpeta, setTieneCarpeta] = useState(false);
    const [guardandoCarpeta, setGuardandoCarpeta] = useState(false);
    const [mostrarModalFirma, setMostrarModalFirma] = useState(false);
    const [observacionFirma, setObservacionFirma] = useState('');
    const [mostrarModalRegistro, setMostrarModalRegistro] = useState(false);
    // La vinculación turno↔cliente vive en un modal que se abre desde la cabecera: así el
    // cliente se muestra en un solo lugar de la ficha, sin el bloque suelto que duplicaba
    // la información. El modal reutiliza VincularClienteTurno tal cual (el mismo componente
    // que usa el modal de detalle del turnero).
    const [mostrarModalVinculo, setMostrarModalVinculo] = useState(false);
    // Cliente asociado al turno: se resuelve una vez al entrar (ya sea porque ya existía en la
    // base o porque se acaba de registrar) y se usa para el botón de registro, los trámites
    // existentes y el alta de trámites nuevos.
    const [clienteAtencion, setClienteAtencion] = useState(null);
    const [tramitesCliente, setTramitesCliente] = useState([]);
    const [cargandoTramites, setCargandoTramites] = useState(false);

    // --- Modal de inicio de trámites (RTI/ART/Jubilación/PUAM/Plan de Pago/Reajuste/PNC/Amparo PNC) ---
    const [tramiteModalTipo, setTramiteModalTipo] = useState(null);
    // true cuando el formulario abierto es el segundo de RTI↔ART, pedido desde el primero.
    const [esComplementario, setEsComplementario] = useState(false);
    const [cuilParaModal, setCuilParaModal] = useState(null);
    const [toast, setToast] = useState(null);
    const [motivosRechazo, setMotivosRechazo] = useState([]);
    const [resultadosAtencion, setResultadosAtencion] = useState([]);

    useEffect(() => {
        DatosMaestrosService.getMotivosRechazo()
            .then((res) => setMotivosRechazo(res.data || []))
            .catch(() => setMotivosRechazo([]));
        DatosMaestrosService.getResultadosAtencion()
            .then((res) => setResultadosAtencion(res.data || []))
            .catch(() => setResultadosAtencion([]));
    }, []);

    const cargarTurno = async () => {
        setCargando(true);
        setError('');
        try {
            const data = await obtenerTurno(idTurnoEval);
            setTurno(data);
            setNotas(data?.notasAtencion || '');
            setMotivoNoAvance(data?.motivoNoAvance || '');
            setObservacionMotivoNoAvance(data?.observacionMotivoNoAvance || '');
            setResultadoAtencion(data?.resultadoAtencion || '');
            setTieneCarpeta(!!data?.tieneCarpeta);
        } catch (e) {
            if (!turnoInicial) {
                setError(e?.response?.data?.mensaje || 'No se pudo cargar el turno.');
            }
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        const idTurnoInicial = resolverIdTurno(turnoInicial);
        if (turnoInicial && String(idTurnoInicial) === String(idTurnoEval)) {
            setTurno(turnoInicial);
            setNotas(turnoInicial?.notasAtencion || '');
            setMotivoNoAvance(turnoInicial?.motivoNoAvance || '');
            setObservacionMotivoNoAvance(turnoInicial?.observacionMotivoNoAvance || '');
            setResultadoAtencion(turnoInicial?.resultadoAtencion || '');
            setTieneCarpeta(!!turnoInicial?.tieneCarpeta);
        }
        cargarTurno();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idTurnoEval]);

    useEffect(() => {
        if (!toast) return undefined;
        const timeoutId = setTimeout(() => setToast(null), 4500);
        return () => clearTimeout(timeoutId);
    }, [toast]);

    const estadoActual = useMemo(() => normalizarEstado(turno?.estado), [turno?.estado]);

    // Borrador de la atención: notas, motivo de no avance y resultado se guardan solos (tras una
    // pausa corta al tipear) mientras la atención está EN_CURSO, para que no se pierdan si el
    // operador sale de la pantalla y vuelve. La referencia recuerda lo último persistido: evita
    // reenviar lo mismo y, sobre todo, guardar como "cambio" los valores recién cargados del turno.
    const idTurnoBorrador = resolverIdTurno(turno);
    const ultimoBorradorGuardado = useRef(null);
    const [estadoBorrador, setEstadoBorrador] = useState('');

    useEffect(() => {
        ultimoBorradorGuardado.current = null;
        setEstadoBorrador('');
        setAgregarVolverAContactar(false);
        setMesesVolverAContactar(0);
    }, [idTurnoBorrador]);

    useEffect(() => {
        if (!idTurnoBorrador || cargando || estadoActual !== 'EN_CURSO') return undefined;
        const borrador = { notasAtencion: notas, motivoNoAvance, observacionMotivoNoAvance, resultadoAtencion };
        const clave = JSON.stringify(borrador);
        if (ultimoBorradorGuardado.current === null) {
            ultimoBorradorGuardado.current = clave;
            return undefined;
        }
        if (clave === ultimoBorradorGuardado.current) return undefined;
        const timeoutId = setTimeout(async () => {
            setEstadoBorrador('guardando');
            try {
                await guardarBorradorAtencion(idTurnoBorrador, borrador);
                ultimoBorradorGuardado.current = clave;
                setEstadoBorrador('guardado');
            } catch (e) {
                setEstadoBorrador('error');
            }
        }, 800);
        return () => clearTimeout(timeoutId);
    }, [idTurnoBorrador, cargando, estadoActual, notas, motivoNoAvance, observacionMotivoNoAvance, resultadoAtencion]);

    // Cliente y trámites del turno, resueltos una sola vez cuando cambia el turno (no en cada
    // actualización de estado: cambiarEstado devuelve un turno nuevo con el mismo idTurno, y
    // eso no debe disparar de nuevo la búsqueda). Cubre tanto un cliente que ya existía en la
    // base como uno recién registrado desde esta misma pantalla.
    const idTurnoParaResolverCliente = resolverIdTurno(turno);

    const cargarTramitesCliente = useCallback(async (cuil) => {
        if (!cuil) {
            setTramitesCliente([]);
            return;
        }
        setCargandoTramites(true);
        try {
            const listado = await getTramites(0, 200, cuil, null, null, '');
            const items = Array.isArray(listado) ? listado : (listado?.content || []);
            setTramitesCliente(items.filter(esTramiteActivo));
        } catch (e) {
            setTramitesCliente([]);
        } finally {
            setCargandoTramites(false);
        }
    }, []);

    useEffect(() => {
        if (!idTurnoParaResolverCliente) return undefined;
        let activo = true;
        (async () => {
            try {
                const cliente = await resolverClienteAsociadoTurno(turno);
                if (!activo) return;
                setClienteAtencion(cliente);
                await cargarTramitesCliente(cliente?.cuil || null);
                cargarAportesCliente(cliente?.cuil || null);
            } catch (e) {
                if (activo) setTramitesCliente([]);
            }
        })();
        return () => { activo = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idTurnoParaResolverCliente]);

    // Cantidad de aportes (meses) que el cliente tiene cargados en el sistema. null = sin cargar/desconocido.
    const [aportesCliente, setAportesCliente] = useState(null);
    const cargarAportesCliente = useCallback(async (cuil) => {
        if (!cuil) { setAportesCliente(null); return; }
        try {
            const data = await obtenerResumenAportesCliente(cuil);
            setAportesCliente(Number(data?.aportesActuales) || 0);
        } catch (e) {
            setAportesCliente(null);
        }
    }, []);

    // Re-resuelve el cliente y recarga sus trámites + aportes (para el botón "Actualizar" tras cargar el
    // histórico laboral en la otra pestaña: así se ven los datos ya sincronizados).
    const [refrescandoCliente, setRefrescandoCliente] = useState(false);
    const refrescarCliente = useCallback(async () => {
        setRefrescandoCliente(true);
        try {
            const cliente = await resolverClienteAsociadoTurno(turno);
            setClienteAtencion(cliente);
            await Promise.all([
                cargarTramitesCliente(cliente?.cuil || null),
                cargarAportesCliente(cliente?.cuil || null),
            ]);
        } catch (e) {
            // noop: si falla, se mantiene el estado actual
        } finally {
            setRefrescandoCliente(false);
        }
    }, [turno, cargarTramitesCliente, cargarAportesCliente]);

    // Abre la Calculadora de Aportes en una pestaña nueva, preseleccionando el cliente si hay CUIL.
    const abrirHistorialLaboral = useCallback(() => {
        const cuil = String(clienteAtencion?.cuil || turno?.cuil || turno?.dni || '').replace(/\D/g, '');
        const url = `/herramientas/historial-laboral${cuil ? `?cuil=${cuil}` : ''}`;
        window.open(url, '_blank', 'noopener');
    }, [clienteAtencion, turno]);

    // Los turnos generados por una ida a ANSES tienen un flujo propio: no se atienden en el
    // mostrador ni abren trámites, solo se registra la firma y la salida hacia el organismo.
    const esAcompanamientoAnses = useMemo(
        () => String(turno?.modalidad || '').trim().toUpperCase() === 'ANSES',
        [turno?.modalidad]
    );

    // El que viene a pagar tampoco se atiende como mostrador: la ficha es el saldo del cobro y el
    // registro del pago. Se mira el tipo de turno y el área, no la modalidad: un turno de cobro lo
    // carga recepción por el circuito normal (modalidad GENERAL), a diferencia del de ANSES que lo
    // genera el otro módulo. El día que exista "citar a pagar" y con él una modalidad COBRO, esta
    // condición sigue siendo válida sin tocarla.
    const esAtencionCobro = useMemo(() => {
        const tipo = String(turno?.tipoTramite || '').trim().toUpperCase();
        const area = String(turno?.atencion || '').trim().toUpperCase();
        return tipo === 'COBRO' || area === 'COBROS';
    }, [turno?.tipoTramite, turno?.atencion]);

    const nombreTramite = useMemo(() => formatearTipoTramite(turno?.tipoTramite), [turno?.tipoTramite]);

    // Volvió de ANSES para abrir el plan de pago (reingreso APERTURA_PLAN, 15-oct-2026): ficha propia.
    const esAperturaPlan = turno?.tipoReingreso === 'APERTURA_PLAN';
    const [recargaApertura, setRecargaApertura] = useState(0);
    // Fecha de liquidar con la que se precarga la Jubilación creada desde la apertura del plan.
    const [fechaLiquidarModal, setFechaLiquidarModal] = useState(null);

    const handleEmpezarAtencion = async () => {
        if (!turno) return;

        // Un operador no debería atender a más de un cliente a la vez. Si ya tiene otra atención
        // EN_CURSO, se avisa y hay que confirmar para llamar igual (por si no pudo cerrar la anterior).
        if (user?.id) {
            try {
                const hoy = new Date();
                const fechaHoy = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;
                const turnosHoy = await listarRango(fechaHoy, fechaHoy);
                const enCurso = (turnosHoy || []).find((t) =>
                    String(t?.estado || '').trim().toUpperCase().replace(/\s+/g, '_') === 'EN_CURSO'
                    && Number(t?.idOperador) === Number(user.id)
                    && t?.idTurno !== turno.idTurno);
                if (enCurso) {
                    const nombreOtro = apellidoNombre(enCurso.apellido, enCurso.nombre) || 'otro cliente';
                    showConfirm(
                        `Ya tenés una atención en curso (${nombreOtro}). Deberías terminar esa atención antes de llamar a otro. ¿Llamar a este cliente igual de todos modos?`,
                        iniciarAtencionEnCurso,
                        'Ya tenés una atención en curso',
                        'warning'
                    );
                    return;
                }
            } catch (e) {
                // Si falla el chequeo, no bloqueamos: se permite continuar.
            }
        }

        iniciarAtencionEnCurso();
    };

    // Efectivamente pasa el turno a EN_CURSO (se separa para poder llamarlo tras confirmar el
    // aviso de "ya tenés una atención en curso").
    const iniciarAtencionEnCurso = async () => {
        setGuardando(true);
        setError('');
        try {
            const extra = { notasAtencion: notas };
            if (user?.id) {
                extra.idOperador = user.id;
            }
            const actualizado = await cambiarEstado(turno.idTurno, 'EN_CURSO', extra);
            setTurno(actualizado);
        } catch (e) {
            setError(e?.response?.data?.mensaje || 'No se pudo actualizar el turno.');
        } finally {
            setGuardando(false);
        }
    };

    const handleToggleCarpeta = async (valor) => {
        setTieneCarpeta(valor);
        setGuardandoCarpeta(true);
        try {
            const actualizado = await actualizarCarpetaTurno(turno.idTurno, valor);
            setTurno((prev) => ({ ...prev, tieneCarpeta: actualizado.tieneCarpeta }));
        } catch (e) {
            setTieneCarpeta(!valor);
            setError(e?.response?.data?.mensaje || 'No se pudo guardar el estado de la carpeta.');
        } finally {
            setGuardandoCarpeta(false);
        }
    };

    // Trámites abiertos en ESTA atención: los que tienen este turno como origen, que es el mismo
    // criterio de la conversión en los reportes. Los trámites activos que el cliente ya traía de
    // antes no cuentan: antes alcanzaba con tener uno viejo para cerrar sin motivo, y la atención
    // quedaba sin trámite, sin motivo y sin carpeta.
    const idTurnoActual = resolverIdTurno(turno);
    const tramitesDeEstaAtencion = useMemo(
        () => (tramitesCliente || []).filter(
            (t) => idTurnoActual != null && t?.idTurnoOrigen != null && Number(t.idTurnoOrigen) === Number(idTurnoActual)
        ),
        [tramitesCliente, idTurnoActual]
    );

    // El resultado que corresponde según lo que pasó en la atención: con algún trámite que arranca ya,
    // "Inicia ahora"; si todos los abiertos acá quedaron con fecha de liquidar, "Carpeta a futuro". Sin
    // trámite no hay sugerencia. El operador puede elegir otro, pero se le avisa (decisión 28-sep-2026).
    // Solo es "a futuro" un trámite que queda esperando un mes POSTERIOR al de la atención: con fecha
    // de liquidar en el mismo mes arranca ahora. El Plan de Pago siempre sugiere "Inicia ahora": si se
    // inicia es instantáneo, y su fecha de liquidar se suele confundir con la fecha de jubilación
    // (30-sep-2026). Es solo la sugerencia: el operador elige.
    const mesAtencion = useMemo(() => {
        if (turno?.fechaTurno) return String(turno.fechaTurno).slice(0, 7);
        const hoy = new Date();
        return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}`;
    }, [turno?.fechaTurno]);
    const resultadoSugerido = useMemo(() => {
        if (tramitesDeEstaAtencion.length === 0) return '';
        const quedaParaMasAdelante = (t) => normalizarTipoTramite(t?.tipoTramite) !== 'PLAN_PAGO'
            && t?.iniciarDiferido && t?.fechaInicioEstimada
            && String(t.fechaInicioEstimada).slice(0, 7) > mesAtencion;
        return tramitesDeEstaAtencion.every(quedaParaMasAdelante) ? RESULTADO_CARPETA_A_FUTURO : RESULTADO_INICIA_AHORA;
    }, [tramitesDeEstaAtencion, mesAtencion]);

    // El backend ya resolvió si la persona era cliente del estudio ANTES de esta visita (V229):
    // el check de carpeta, o un trámite o una visita anterior en el sistema. Cuando hay esa
    // evidencia y el check todavía no está marcado, se marca solo y se avisa: el dato define si la
    // atención cuenta como cliente nuevo en los reportes, y no puede depender de que alguien se
    // acuerde. Queda desmarcable — la evidencia puede ser de otra persona mal vinculada.
    const [carpetaSugerida, setCarpetaSugerida] = useState(false);
    const sugerenciaAplicadaRef = useRef(null);

    useEffect(() => {
        if (!idTurnoActual || estadoActual !== 'EN_CURSO') return;
        if (sugerenciaAplicadaRef.current === idTurnoActual) return;
        if (tieneCarpeta || turno?.yaEraCliente !== true) return;
        sugerenciaAplicadaRef.current = idTurnoActual;
        setCarpetaSugerida(true);
        handleToggleCarpeta(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idTurnoActual, estadoActual, tieneCarpeta, turno?.yaEraCliente]);

    const handleFinalizarAtencion = async () => {
        if (!turno) return;
        // Mientras se recarga la lista de trámites (justo después de abrir uno) la ficha todavía no
        // sabe si en esta atención se abrió algo, y cualquier decisión sobre el resultado sería sobre
        // una lista vieja. El botón también se deshabilita; esto cubre un clic que llegue antes del re-render.
        if (cargandoTramites) return;

        // Resultado obligatorio. Si el operador no eligió nada y en esta atención se abrió un trámite,
        // queda el sugerido (Inicia ahora / Carpeta a futuro). Sin trámite lo tiene que elegir, salvo que
        // ya tenga carpeta: vino por un trámite en curso, se guarda sin resultado y los reportes lo dejan
        // fuera de las estadísticas.
        const catalogo = (nombre) => resultadosAtencion.find((r) => esResultado(r.nombre, nombre))?.nombre || nombre;
        const resultadoAFinalizar = resultadoAtencion || (resultadoSugerido ? catalogo(resultadoSugerido) : '');
        if (!resultadoAFinalizar && !tieneCarpeta) {
            showWarning('Elegí el resultado de la atención antes de finalizarla.', 'Falta el resultado de la atención');
            return;
        }

        // El motivo de no avance es solo para "No viable" y "No quiso dejar carpeta": explica por qué la
        // atención no terminó en un trámite. Con cualquier otro resultado no se pide ni se guarda.
        const eligioSinTramite = esResultadoSinTramite(resultadoAFinalizar);
        const hayTramite = tramitesDeEstaAtencion.length > 0;
        if (eligioSinTramite && !hayTramite && !motivoNoAvance) {
            showWarning('El resultado es «' + resultadoAFinalizar + '»: elegí el motivo de no avance antes de finalizar.', 'Falta el motivo de no avance');
            return;
        }

        // El resultado lo elige el operador, pero si no coincide con lo que pasó en la atención se avisa
        // antes de guardar: es lo que hace que "Inicia ahora + Carpeta a futuro" dé lo mismo que los
        // trámites abiertos en las estadísticas.
        const eligioConTramite = esResultado(resultadoAFinalizar, RESULTADO_INICIA_AHORA)
            || esResultado(resultadoAFinalizar, RESULTADO_CARPETA_A_FUTURO);
        let aviso = null;
        if (hayTramite && eligioSinTramite) {
            aviso = 'En esta atención se abrió un trámite, pero el resultado elegido es «' + resultadoAFinalizar + '». Si el trámite es de esta atención, el resultado debería ser «' + resultadoSugerido + '». ¿Finalizar igual como «' + resultadoAFinalizar + '»?';
        } else if (eligioConTramite && !hayTramite) {
            aviso = 'En esta atención no se abrió ningún trámite desde la ficha. Si el trámite que ves es uno que el cliente ya tenía, o lo abriste en otra pantalla, no va a quedar vinculado a esta atención. ¿Finalizar igual como «' + resultadoAFinalizar + '»?';
        } else if (hayTramite && eligioConTramite && !esResultado(resultadoAFinalizar, resultadoSugerido)) {
            aviso = esResultado(resultadoSugerido, RESULTADO_CARPETA_A_FUTURO)
                ? 'Los trámites abiertos en esta atención quedan para liquidar en un mes posterior: el resultado sugerido es «Carpeta a futuro». ¿Finalizar igual como «' + resultadoAFinalizar + '»?'
                : 'En esta atención se abrió un trámite que arranca ahora: el resultado sugerido es «Inicia ahora». ¿Finalizar igual como «' + resultadoAFinalizar + '»?';
        }

        const datos = {
            resultadoAtencion: resultadoAFinalizar,
            motivoNoAvance: eligioSinTramite && !hayTramite ? motivoNoAvance : '',
            observacionMotivoNoAvance: eligioSinTramite && !hayTramite ? observacionMotivoNoAvance : '',
            // Solo vale con resultado sin trámite: si el operador tildó y después cambió a
            // "Inicia ahora", la casilla ya no se ve y tampoco se aplica.
            volverAContactar: eligioSinTramite && !hayTramite && agregarVolverAContactar
                ? { avisarDesde: avisarDesdeParaPlazo(mesesVolverAContactar) }
                : null,
        };
        if (aviso) {
            showConfirm(aviso, () => enviarFinalizacion(datos), 'Revisá el resultado de la atención', 'warning');
            return;
        }
        await enviarFinalizacion(datos);
    };

    const enviarFinalizacion = async ({ resultadoAtencion: resultadoAFinalizar, motivoNoAvance: motivo, observacionMotivoNoAvance: observacion, volverAContactar }) => {
        setGuardando(true);
        setError('');
        try {
            const actualizado = await cambiarEstado(turno.idTurno, 'FINALIZADO', {
                notasAtencion: notas, motivoNoAvance: motivo, observacionMotivoNoAvance: observacion, resultadoAtencion: resultadoAFinalizar,
            });
            setTurno(actualizado);
            // Después de finalizar, nunca antes: el backend solo acepta atenciones finalizadas. Si
            // falla, la atención ya quedó cerrada; se avisa y no se sale de la ficha, para que el
            // operador lo lea. Lo puede agregar después desde el histórico de turnos.
            if (volverAContactar) {
                try {
                    await agregarAVolverAContactar({ idTurno: turno.idTurno, avisarDesde: volverAContactar.avisarDesde });
                } catch (e) {
                    showWarning(
                        'La atención quedó finalizada, pero no se pudo agregar al listado «Volver a contactar»: '
                        + mensajeDeError(e, 'error desconocido') + '. Podés agregarla desde el Histórico de turnos.',
                        'No se agregó a Volver a contactar'
                    );
                    return;
                }
            }
            handleSalir();
        } catch (e) {
            setError(e?.response?.data?.mensaje || 'No se pudo finalizar la atención.');
        } finally {
            setGuardando(false);
        }
    };

    // ---- Turnos ANSES ----
    // Si hay firma pendiente hay que decidir antes de que salga: el aviso no bloquea (puede
    // irse sin firmar) pero exige dejar constancia, para que no se pase por alto en silencio.
    const handleSalidaAAnses = () => {
        if (!turno) return;
        if (turno.requiereFirma && !turno.firmaResuelta) {
            setObservacionFirma('');
            setMostrarModalFirma(true);
            return;
        }
        registrarSalidaAAnses();
    };

    const registrarSalidaAAnses = async () => {
        setGuardando(true);
        setError('');
        try {
            const extra = { notasAtencion: notas };
            if (user?.id) extra.idOperador = user.id;
            setTurno(await cambiarEstado(turno.idTurno, 'EN_ANSES', extra));
        } catch (e) {
            setError(e?.response?.data?.mensaje || 'No se pudo registrar la salida hacia ANSES.');
        } finally {
            setGuardando(false);
        }
    };

    // firmo=true: firmó antes de salir. firmo=false: sale igual, con la firma pendiente.
    const resolverFirmaYSalir = async (firmo) => {
        setGuardando(true);
        setError('');
        try {
            await resolverFirmaTurnoAnses(
                turno.idTurnoAnses,
                firmo,
                firmo ? null : (observacionFirma.trim() || 'Salió sin firmar')
            );
            setMostrarModalFirma(false);
            await registrarSalidaAAnses();
        } catch (e) {
            setError(e?.response?.data?.mensaje || 'No se pudo registrar el estado de la firma.');
            setGuardando(false);
        }
    };

    const handleRegresoDeAnses = async () => {
        if (!turno) return;
        setGuardando(true);
        setError('');
        try {
            await cambiarEstado(turno.idTurno, 'FINALIZADO', { notasAtencion: notas });
            handleSalir();
        } catch (e) {
            setError(e?.response?.data?.mensaje || 'No se pudo finalizar el turno.');
        } finally {
            setGuardando(false);
        }
    };

    // Deja persistido en el turno de qué cliente es. Sin esto el cliente registrado (o al que se le
    // abrió un trámite) vivía solo en el estado de esta pantalla: al salir y volver aparecía como
    // no registrado, sus trámites "desaparecían" y se lo volvía a dar de alta (ver V225). Un
    // vínculo que ya existe no se pisa: para cambiarlo está "Cambiar cliente".
    const vincularTurnoConCliente = async (cuil, criterio) => {
        const idTurnoVincular = resolverIdTurno(turno);
        if (!idTurnoVincular || !cuil || turno?.cuilCliente) return;
        try {
            setTurno(await vincularClienteTurno(idTurnoVincular, cuil, criterio));
        } catch (e) {
            mostrarToast('error', 'No se pudo vincular el turno con el cliente. Usá "Vincular cliente" para hacerlo a mano.');
        }
    };

    const handleRegistroExitoso = (clienteNuevo) => {
        setMostrarModalRegistro(false);
        setClienteAtencion(clienteNuevo || null);
        if (clienteNuevo?.cuil) {
            cargarTramitesCliente(clienteNuevo.cuil);
            vincularTurnoConCliente(clienteNuevo.cuil, 'ALTA_EN_ATENCION');
        }
    };

    const mostrarToast = (tipo, mensaje) => setToast({ tipo, mensaje });

    // Alta al vuelo de los catálogos de Datos Maestros desde la ficha (ver
    // SelectorCatalogoConAlta). Se agrega la fila devuelta por el backend a la lista local en
    // vez de recargar todo el catálogo: el orden alfabético lo resuelve el sort de acá.
    const ordenarPorNombre = (lista) =>
        [...lista].sort((a, b) => String(a.nombre).localeCompare(String(b.nombre), 'es', { sensitivity: 'base' }));

    const crearMotivoRechazo = async (nombre) => {
        const { data } = await DatosMaestrosService.createMotivoRechazo({ nombre });
        setMotivosRechazo((prev) => ordenarPorNombre([...prev, data]));
        mostrarToast('success', `Motivo "${data.nombre}" agregado al catálogo.`);
        return data;
    };

    const abrirModalTramite = (tipo) => {
        const cuil = clienteAtencion?.cuil || turno?.cuil || turno?.dni || null;
        setCuilParaModal(cuil);
        setTramiteModalTipo(tipo);
    };

    const cerrarModalTramite = () => {
        setTramiteModalTipo(null);
        setCuilParaModal(null);
        setEsComplementario(false);
        setFechaLiquidarModal(null);
    };

    const handleTramiteCreado = (tipo, tramiteCreado) => {
        cerrarModalTramite();
        if (esAperturaPlan) setRecargaApertura((n) => n + 1);
        const config = configTramite(tipo);
        const idTramite = tramiteCreado?.idTramite ? ` (N° ${tramiteCreado.idTramite})` : '';
        mostrarToast('success', `Trámite ${config?.nombreCorto || tipo} iniciado con éxito${idTramite}.`);
        // El CUIL del trámite creado es el del cliente real: puede no coincidir con cuilParaModal,
        // que sale del CUIL dictado en el turno (o del DNI) si el cliente se eligió o registró
        // dentro del propio formulario.
        const cuilCliente = tramiteCreado?.idCliente || clienteAtencion?.cuil || null;
        if (cuilCliente) {
            // Refresca el listado para que el botón pase a "Ya se inició..." sin recargar la página.
            cargarTramitesCliente(cuilCliente);
            vincularTurnoConCliente(cuilCliente, 'TRAMITE');
            if (!clienteAtencion) {
                getClientePorCuil(cuilCliente).then(setClienteAtencion).catch(() => {});
            }
        } else if (cuilParaModal) {
            cargarTramitesCliente(cuilParaModal);
        }
    };

    // RTI y ART preguntan al terminar si se inicia también el otro. Desde la ficha, el segundo se abre acá
    // mismo y con el mismo turno de origen: antes el formulario navegaba a la página suelta de alta y el
    // segundo trámite quedaba sin atención (ninguna atención tenía dos trámites vinculados, 30-sep-2026).
    const handleIniciarComplementario = (tipo, tramiteCreado) => {
        const otro = tipo === 'RTI' ? 'ART' : 'RTI';
        const cuil = tramiteCreado?.idCliente || tramiteCreado?.cliente?.cuil || clienteAtencion?.cuil || cuilParaModal;
        handleTramiteCreado(tipo, tramiteCreado);
        setCuilParaModal(cuil);
        setTramiteModalTipo(otro);
        // El segundo no vuelve a preguntar por el primero (sería un ida y vuelta sin fin).
        setEsComplementario(true);
    };

    if (cargando) {
        return (
            <div className="homepage-container area-recepcion">
                <div className="loading-state">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-3 mb-0">Cargando detalle del turno...</p>
                </div>
            </div>
        );
    }

    if (!turno) {
        return (
            <div className="homepage-container area-recepcion">
                <div className="empty-state-eventos">
                    <i className="bi bi-exclamation-triangle"></i>
                    <h5>No se encontró el turno</h5>
                    <p>{error || 'El turno no existe o fue eliminado.'}</p>
                </div>
            </div>
        );
    }

    // ============================================
    // BOTONES PARA INICIAR TRÁMITES
    // ============================================
    const renderBotonTramite = (tipo) => {
        const config = TRAMITES_CONFIG[tipo];
        if (!config) return null;

        // El más reciente si hubiera más de un trámite activo del mismo tipo.
        const tramiteExistente = tramitesCliente
            .filter((t) => normalizarTipoTramite(t?.tipoTramite) === tipo)
            .sort((a, b) => Number(b?.idTramite || 0) - Number(a?.idTramite || 0))[0];

        if (tramiteExistente) {
            return (
                <Button
                    key={tipo}
                    variant="success"
                    className={`atencion-btn-tramite atencion-btn-tramite-iniciado ${config.className}`}
                    onClick={() => navigate(`${config.ruta}/${tramiteExistente.idTramite}`)}
                >
                    <i className="bi bi-check-circle-fill me-2"></i>
                    Ya se inició un trámite {config.nombreCorto}
                    <i className="bi bi-arrow-right-short ms-1"></i>
                </Button>
            );
        }

        return (
            <Button
                key={tipo}
                className={`atencion-btn-tramite ${config.className}`}
                onClick={() => abrirModalTramite(tipo)}
                disabled={cargandoTramites}
            >
                {cargandoTramites ? (
                    <Spinner animation="border" size="sm" className="me-2" />
                ) : (
                    <i className={`bi ${config.icono} me-2`}></i>
                )}
                {config.nombreCorto}
            </Button>
        );
    };

    const renderBotonesTramites = () => {
        const [principal, ...secundarios] = resolverOrdenTramitesPorTipo(turno?.tipoTramite);
        const resto = [...secundarios, ...TRAMITES_PREVISIONALES_FIJOS, ...TRAMITES_ADICIONALES_FIJOS];

        return (
            <>
                <div className="atn-tramite-primary-cta">
                    {renderBotonTramite(principal)}
                </div>

                <div className="atn-tramites-grid">
                    {resto.map((tipo) => renderBotonTramite(tipo))}
                    <Button
                        className="atencion-btn-tramite atn-tramite-btn--dashed"
                        onClick={() => abrirModalTramite('GENERICO')}
                        disabled={cargandoTramites}
                    >
                        <i className="bi bi-file-earmark-plus me-2"></i>
                        Otro trámite…
                    </Button>
                </div>
            </>
        );
    };

    // Cuándo se liquida cada trámite abierto en ESTA atención. La fecha se carga en el formulario
    // de inicio (campo "Fecha de liquidar"), acá solo se muestra el desenlace: sin fecha el trámite
    // arranca ahora, con fecha queda esperando ese mes en el listado "A liquidar".
    const renderLiquidacionDeEstaAtencion = () => {
        if (tramitesDeEstaAtencion.length === 0) return null;

        return (
            <div className="atn-note-block atn-liquidacion">
                <h5 className="atn-section-title">
                    <i className="bi bi-calendar-check me-2"></i>
                    Inicio de los trámites abiertos acá
                </h5>
                <ul className="atn-liquidacion-lista">
                    {tramitesDeEstaAtencion.map((tramite) => {
                        const tipo = normalizarTipoTramite(tramite?.tipoTramite);
                        const nombre = TRAMITES_CONFIG[tipo]?.nombreCorto
                            || tramite?.tipoTramite?.nombre
                            || 'Otro trámite';
                        const diferido = tramite?.iniciarDiferido && tramite?.fechaInicioEstimada;
                        return (
                            <li key={tramite.idTramite}>
                                <span className="atn-liquidacion-tramite">{nombre}</span>
                                <span className={`atn-liquidacion-chip${diferido ? ' atn-liquidacion-chip--diferido' : ''}`}>
                                    <i className={`bi ${diferido ? 'bi-clock-history' : 'bi-play-fill'} me-1`}></i>
                                    {diferido
                                        ? `Liquidar: ${formatearMesAnio(tramite.fechaInicioEstimada)}`
                                        : 'Inicia ahora'}
                                </span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    };

    // ============================================
    // CARÁTULAS DE LOS TRÁMITES YA INICIADOS
    // ============================================
    // Un botón por trámite activo del cliente que tenga plantilla de carátula. Es el mismo
    // componente que usa la ficha del trámite, así que Jubilación despliega acá también su
    // menú de las dos leyes. Los tipos sin plantilla no aparecen. GENERICO
    // ("Otro Trámite") es la excepción: no tiene tipoTramite propio en el registro, pero sí
    // ofrece las dos carátulas de Pensión (ver botonesPension más abajo) — es el único uso
    // real de "Otro Trámite" hoy en el estudio.
    const renderBotonesCaratula = () => {
        const conCaratula = tramitesCliente
            .map((tramite) => ({ tramite, tipo: normalizarTipoTramite(tramite?.tipoTramite) }))
            .filter(({ tipo }) => Boolean(caratulaRegistry[tipo]));

        // El sistema no tiene módulo de Pensión propio: esos trámites se cargan como GENERICO
        // ("Iniciar Otro Trámite"). Como tramite.tipoTramite nunca vale "PENSION", el mapeo
        // genérico de arriba (normalizarTipoTramite → caratulaRegistry[tipo]) nunca los
        // encuentra — se resuelve a mano acá: cualquier trámite GENERICO activo del cliente
        // ofrece las dos carátulas de Pensión.
        const botonesPension = tramitesCliente
            .filter((tramite) => normalizarTipoTramite(tramite?.tipoTramite) === 'GENERICO')
            .flatMap((tramite) => ([
                { tramite, tipo: 'PENSION', etiqueta: 'Generar Carátula Pensión' },
                { tramite, tipo: 'REAJUSTE_PENSION', etiqueta: 'Generar Carátula Reajuste de Pensión' },
            ]));

        if (conCaratula.length === 0 && botonesPension.length === 0) {
            return null;
        }

        return (
            <div className="atn-note-block">
                <h5 className="atn-section-title">
                    <i className="bi bi-file-earmark-text me-2"></i>
                    Carátulas
                </h5>
                <div className="atencion-caratulas-lista">
                    {conCaratula.map(({ tramite, tipo }) => (
                        <BotonGenerarCaratula
                            key={tramite.idTramite}
                            tipo={tipo}
                            idTramite={tramite.idTramite}
                            className="atencion-btn-caratula d-inline-flex align-items-center gap-2"
                            etiqueta={`Generar Carátula ${TRAMITES_CONFIG[tipo].nombreCorto}`}
                        />
                    ))}
                    {botonesPension.map(({ tramite, tipo, etiqueta }) => (
                        <BotonGenerarCaratula
                            key={`${tipo}-${tramite.idTramite}`}
                            tipo={tipo}
                            idTramite={tramite.idTramite}
                            className="atencion-btn-caratula d-inline-flex align-items-center gap-2"
                            etiqueta={etiqueta}
                        />
                    ))}
                </div>
            </div>
        );
    };

    const renderEtapaDatos = () => (
        <div className="atn-shell">
            <div className="atn-card atn-header">
                <div className="atn-header-top">
                    <div>
                        <h2 className="atn-title">Datos del turno</h2>
                        <p className="atn-subtitle">Verificá los datos del cliente antes de empezar la atención.</p>
                    </div>
                    <span className="atn-badge-etapa">Etapa 1</span>
                </div>
            </div>

            <div className="atn-card">
                <div className="atn-field-grid">
                    <CampoDato etiqueta="Cliente" valor={apellidoNombre(turno.apellido, turno.nombre)} />
                    <CampoDato etiqueta="CUIL" valor={turno.cuil || turno.dni || 'Sin dato'} muted={!(turno.cuil || turno.dni)} />
                    <CampoDato etiqueta="Tipo de Trámite" valor={nombreTramite} />
                    <CampoDato etiqueta="Fecha y Hora" valor={`${formatearFecha(turno.fechaTurno)} - ${formatearHorario(turno.horario)}`} />
                    <CampoDato etiqueta="Teléfono" valor={turno.telefonoCliente || 'Sin dato'} muted={!turno.telefonoCliente} />
                    <CampoDato etiqueta="Fecha de creación" valor={formatearFechaHora(turno.creadoEn)} />
                    {turno.referencia && (
                        <CampoDato etiqueta="Referencia" valor={turno.referencia} />
                    )}
                    <CampoDato
                        etiqueta="Primera vez"
                        valor={
                            turno.esPrimeraVez == null
                                ? 'No registrado'
                                : turno.esPrimeraVez ? 'Sí, primera vez en el estudio' : 'No, ya había venido'
                        }
                    />
                </div>

                <div className="atn-field-divider" />

                <div className="atn-note-block">
                    <h5 className="atn-section-title">Motivo de consulta</h5>
                    <p>{turno.motivo || 'Sin motivo cargado.'}</p>
                </div>
                <div className="atn-note-block">
                    <h5 className="atn-section-title">Observaciones de recepción</h5>
                    <p>{turno.notasAtencion || 'Sin observaciones.'}</p>
                </div>
            </div>

            <div className="atn-actions">
                <Button
                    className="atn-btn-primary"
                    onClick={handleEmpezarAtencion}
                    disabled={guardando}
                >
                    {guardando ? (
                        <Spinner animation="border" size="sm" className="me-2" />
                    ) : (
                        <i className="bi bi-play-fill me-2"></i>
                    )}
                    Empezar Atención
                </Button>
            </div>
        </div>
    );

    const renderEtapaFicha = () => {
        const soloLectura = estadoActual === 'FINALIZADO';

        // Quién es la persona que se está atendiendo. El vínculo persistido (turno.cuilCliente,
        // que fija el matcher automático o la vinculación manual) manda sobre lo que haya
        // adivinado la heurística local: si alguien ya decidió de qué cliente es este turno,
        // eso es lo que hay que mostrar.
        const vinculado = Boolean(turno.cuilCliente);
        const leyendaVinculo = LEYENDA_CRITERIO[turno.vinculoClienteCriterio] || 'vinculado';
        const nombreCabecera = vinculado
            ? apellidoNombre(turno.clienteApellido, turno.clienteNombre)
            : apellidoNombre(turno.apellido, turno.nombre);
        const iniciales = (nombreCabecera || '')
            .split(/[\s,]+/)
            .filter(Boolean)
            .slice(0, 2)
            .map((parte) => parte.charAt(0))
            .join('')
            .toUpperCase() || '?';
        // CUIL con el que abrir la ficha del cliente: sirve tanto el vínculo persistido como el
        // que resolvió la heurística, porque en los dos casos hay una ficha real detrás.
        const cuilFichaCliente = clienteAtencion?.cuil || turno.cuilCliente || null;

        return (
            <div className="atn-shell">
                <div className="atn-card atn-header">
                    <div className="atn-header-top">
                        <div>
                            <h2 className="atn-title">Atención y Ficha</h2>
                            <p className="atn-subtitle">
                                {soloLectura
                                    ? 'Resumen de la atención ya finalizada.'
                                    : 'Registrá la atención, gestioná el cliente y sus trámites, y finalizá cuando corresponda.'}
                            </p>
                        </div>
                        <span className={`atn-badge-etapa${soloLectura ? ' atn-badge-etapa--success' : ''}`}>Etapa 2</span>
                    </div>

                    <div className="atn-header-client">
                        <div className="atn-avatar-circle">{iniciales}</div>
                        <div className="atn-header-body">
                            <div className="atn-header-name">{nombreCabecera}</div>

                            {/* Una sola fila de metadatos: el CUIL y, al lado, el pill que dice si
                                el cliente ya tiene ficha. Que la tenga es lo primero que necesita
                                saber quien atiende (cambia si hay que registrarlo o si puede ir
                                directo al historial), así que el pill lleva también el acceso. */}
                            <div className="atn-header-meta">
                                <span>
                                    CUIL {turno.cuilCliente || turno.cuil || turno.dni || 'Sin dato'}
                                    {' · '}{etiquetaEstado(turno.estado)}
                                    {vinculado && ` · ${leyendaVinculo}`}
                                </span>

                                {cuilFichaCliente && (
                                    <span className="atn-cliente-registrado">
                                        <i className="bi bi-person-check-fill"></i>
                                        <span>Cliente registrado en el sistema</span>
                                        <button
                                            type="button"
                                            className="atn-cliente-registrado-link"
                                            onClick={() => navigate(`/clientes/vista-detallada/${cuilFichaCliente}`)}
                                        >
                                            Ver ficha
                                            <i className="bi bi-arrow-right-short"></i>
                                        </button>
                                    </span>
                                )}
                            </div>
                        </div>

                        {!soloLectura && (
                            <div className="atn-header-actions">
                                {/* Un único lugar para corregir con quién se está hablando: abre
                                    VincularClienteTurno en un modal (sugerencia, búsqueda manual
                                    y desvincular). */}
                                <Button
                                    variant="outline-secondary"
                                    className="atn-btn-secondary"
                                    onClick={() => setMostrarModalVinculo(true)}
                                    title={vinculado
                                        ? 'Quitar el vínculo entre este turno y la ficha del cliente'
                                        : 'Vincular este turno con la ficha del cliente del estudio'}
                                >
                                    <i className={`bi ${vinculado ? 'bi-person-dash-fill' : 'bi-person-check-fill'} me-2`}></i>
                                    {vinculado ? 'Desvincular' : 'Vincular cliente'}
                                </Button>

                                {!clienteAtencion && (
                                    <Button
                                        variant="outline-primary"
                                        className="atn-btn-secondary"
                                        onClick={() => setMostrarModalRegistro(true)}
                                    >
                                        <i className="bi bi-person-plus-fill me-2"></i>
                                        Registrar Cliente
                                    </Button>
                                )}

                                {aportesCliente > 0 && (
                                    <Button
                                        variant="success"
                                        className="atn-btn-secondary atn-btn-secondary--success"
                                        disabled
                                        title="El cliente ya tiene el histórico laboral cargado"
                                    >
                                        <i className="bi bi-check-circle-fill me-2"></i>
                                        Aportes cargados ({aportesCliente} {aportesCliente === 1 ? 'mes' : 'meses'})
                                    </Button>
                                )}

                                <Button
                                    variant="outline-secondary"
                                    className="atn-btn-secondary"
                                    onClick={abrirHistorialLaboral}
                                    title="Abre la Calculadora de Aportes en una pestaña nueva"
                                >
                                    <i className="bi bi-calculator me-2"></i>
                                    {aportesCliente > 0 ? 'Ver / recargar histórico' : 'Cargar histórico laboral'}
                                </Button>

                                <Button
                                    variant="outline-secondary"
                                    className="atn-btn-secondary atn-btn-secondary--accent"
                                    onClick={refrescarCliente}
                                    disabled={refrescandoCliente}
                                    title="Actualizar para ver si ya se sincronizaron los aportes importados"
                                >
                                    <i className="bi bi-arrow-clockwise me-2"></i>
                                    {refrescandoCliente ? 'Actualizando…' : 'Actualizar'}
                                </Button>
                            </div>
                        )}
                    </div>
                </div>

                {/* Todo lo que no es la cabecera vive dentro de un mismo contenedor, para que
                    los bloques se lean como un solo cuerpo de trabajo y no como tarjetas
                    sueltas flotando en la página. */}
                <div className="atn-contenido">

                <div className="atn-card">
                    {soloLectura && (
                        <div className="atn-alert-success">
                            <i className="bi bi-check-circle-fill"></i>
                            <span>El turno quedó registrado como <strong>Finalizado</strong>.</span>
                        </div>
                    )}

                    <div className="atn-field-grid">
                        <CampoDato etiqueta="Cliente" valor={apellidoNombre(turno.apellido, turno.nombre)} />
                        <CampoDato etiqueta="Estado" valor={etiquetaEstado(turno.estado)} />
                        <CampoDato etiqueta="Tipo de Trámite" valor={nombreTramite} />
                        <CampoDato etiqueta="Fecha y Hora" valor={`${formatearFecha(turno.fechaTurno)} - ${formatearHorario(turno.horario)}`} />
                        <CampoDato etiqueta="Teléfono" valor={turno.telefonoCliente || 'Sin dato'} muted={!turno.telefonoCliente} />
                        <CampoDato etiqueta="CUIL" valor={turno.cuil || turno.dni || 'Sin dato'} muted={!(turno.cuil || turno.dni)} />
                        <CampoDato etiqueta="Referencia" valor={turno.referencia || 'Sin dato'} muted={!turno.referencia} />
                        {soloLectura && (
                            <>
                                <CampoDato
                                    etiqueta="Atendido por"
                                    valor={turno.operadorNombre || turno.usuarioAtiendeNombre || 'Sin dato'}
                                    muted={!(turno.operadorNombre || turno.usuarioAtiendeNombre)}
                                />
                                <CampoDato
                                    etiqueta="Inicio / Fin de atención"
                                    valor={`${formatearFechaHora(turno.inicioAtencion)} — ${formatearFechaHora(turno.finAtencion)}`}
                                />
                                <CampoDato etiqueta="Duración" valor={formatearDuracion(turno.inicioAtencion, turno.finAtencion)} />
                                <CampoDato etiqueta="Área de atención" valor={turno.atencion || 'Sin dato'} muted={!turno.atencion} />
                                {turno.esSobreturno && (
                                    <CampoDato etiqueta="Ingreso" valor="Sobreturno / espontáneo" />
                                )}
                            </>
                        )}
                    </div>

                    <div className="atn-field-divider" />

                    {/* Motivo de consulta: siempre visible (también durante la atención, no solo al finalizar). */}
                    <div className="atn-note-block" style={{ marginTop: 0 }}>
                        <h5 className="atn-section-title">Motivo de consulta</h5>
                        <p>{turno.motivo || 'Sin motivo cargado.'}</p>
                    </div>
                </div>

                <div className="atn-card">
                    {soloLectura ? (
                        <div className="atn-note-block" style={{ marginTop: 0 }}>
                            <h5 className="atn-section-title">Notas registradas</h5>
                            <p>{turno.notasAtencion || 'Sin notas cargadas.'}</p>
                        </div>
                    ) : (
                        <Form.Group>
                            <Form.Label className="atn-form-label">
                                Notas / resultado
                                {estadoBorrador === 'guardando' && <small className="text-muted fw-normal ms-2">Guardando borrador…</small>}
                                {estadoBorrador === 'guardado' && <small className="text-success fw-normal ms-2"><i className="bi bi-check2 me-1" />Borrador guardado</small>}
                                {estadoBorrador === 'error' && <small className="text-danger fw-normal ms-2">No se pudo guardar el borrador</small>}
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={6}
                                className="atn-textarea"
                                value={notas}
                                onChange={(e) => setNotas(e.target.value)}
                                placeholder="Detalle la atención, resultados clave y próximos pasos."
                            />
                        </Form.Group>
                    )}
                </div>

                {/* ¿Ya es cliente del estudio? Es el corte con el que los reportes separan a la gente
                    nueva (V229), además de hacer opcionales el motivo de no avance y el resultado. Va
                    en su propia tarjeta, entre las notas y los trámites: al pie de "Trámites" quedaba
                    escondido y se pasaba por alto. */}
                {!soloLectura && (
                    <div className="atn-card">
                        <div className={`atn-ya-cliente${tieneCarpeta ? ' atn-ya-cliente--activo' : ''}`} style={{ marginTop: 0 }}>
                            <div className="atn-checkbox-row">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="chkCarpetaAtencion"
                                    checked={tieneCarpeta}
                                    disabled={guardandoCarpeta}
                                    onChange={(e) => handleToggleCarpeta(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="chkCarpetaAtencion" style={{ marginBottom: 0 }}>
                                    <i className="bi bi-folder-fill me-1" />
                                    Ya es cliente del estudio (tiene carpeta){guardandoCarpeta ? ' · guardando…' : ''}
                                </label>
                            </div>
                            <p className="atn-form-hint" style={{ margin: '4px 0 0 28px' }}>
                                {carpetaSugerida && tieneCarpeta
                                    ? 'Se marcó solo: esta persona ya tiene trámites o visitas anteriores en el sistema. Desmarcalo si no corresponde.'
                                    : turno?.yaEraCliente === true && !tieneCarpeta
                                        ? 'Esta persona ya tiene trámites o visitas anteriores en el sistema.'
                                        : 'Marcalo si la persona ya era cliente antes de esta visita: define si cuenta como cliente nuevo en los reportes.'}
                            </p>
                        </div>
                    </div>
                )}
                {soloLectura && turno.tieneCarpeta && (
                    <div className="atn-card">
                        <h5 className="atn-section-title"><i className="bi bi-folder-fill me-1" />Carpeta</h5>
                        <p style={{ margin: 0 }}>Ya tiene carpeta (cliente existente).</p>
                    </div>
                )}

                {/* Visitas anteriores de esta misma persona: por qué vino antes y en qué quedó.
                    Es lo que evita volver a empezar de cero una consulta que ya se tuvo. */}
                {(turno?.cuilCliente || clienteAtencion?.cuil) && (
                    <div className="atn-card">
                        <HistorialTurnosCliente
                            cuil={turno?.cuilCliente || clienteAtencion?.cuil}
                            titulo="Visitas anteriores"
                            idTurnoActual={resolverIdTurno(turno)}
                            compacto
                            ocultarTurnoActual
                        />
                    </div>
                )}

                {!soloLectura && (
                    <div className="atn-card">
                        <h5 className="atn-section-title">Trámites</h5>
                        {renderBotonesCaratula()}
                        {renderBotonesTramites()}
                        {renderLiquidacionDeEstaAtencion()}
                    </div>
                )}

                {/* Primero el resultado y después el motivo: el motivo (y "Volver a contactar")
                    solo aparecen según el resultado, así que se lee qué pasó → por qué → qué sigue. */}
                {soloLectura ? (
                    turno.resultadoAtencion && (
                        <div className="atn-card">
                            <h5 className="atn-section-title">Resultado de la atención</h5>
                            <p style={{ margin: 0 }}><strong>{etiquetaResultadoAtencion(turno.resultadoAtencion)}</strong></p>
                        </div>
                    )
                ) : (
                    <div className="atn-card">
                        <h5 className="atn-section-title" style={{ marginBottom: '4px' }}>Resultado de la atención</h5>
                        <p className="atn-form-hint">
                            {tramitesDeEstaAtencion.length > 0 && !resultadoAtencion
                                ? `Obligatorio. Se abrió un trámite en esta atención: si no elegís otro, queda «${resultadoSugerido}».`
                                : tieneCarpeta && !resultadoAtencion
                                    ? 'Opcional — ya tiene carpeta: si no elegís uno, queda como que vino por un trámite en curso.'
                                    : 'Obligatorio. «No viable» pide el motivo de no avance.'}
                        </p>
                        <SelectorCatalogoConAlta
                            value={resultadoAtencion}
                            onChange={setResultadoAtencion}
                            opciones={resultadosAtencion}
                            placeholder="Escribí para buscar un resultado"
                            permitirAlta={false}
                        />
                    </div>
                )}

                {soloLectura ? (
                    turno.motivoNoAvance && (
                        <div className="atn-card">
                            <h5 className="atn-section-title">Motivo de no avance</h5>
                            <p style={{ margin: 0 }}><strong>{turno.motivoNoAvance}</strong></p>
                            {turno.observacionMotivoNoAvance && (
                                <>
                                    <p className="mt-2 mb-0"><strong>Detalles:</strong></p>
                                    <p style={{ margin: 0 }}>{turno.observacionMotivoNoAvance}</p>
                                </>
                            )}
                        </div>
                    )
                ) : (tramitesDeEstaAtencion.length > 0 || !esResultadoSinTramite(resultadoAtencion)) ? null : (
                    <div className="atn-card">
                        <h5 className="atn-section-title" style={{ marginBottom: '4px' }}>Motivo de no avance</h5>
                        <p className="atn-form-hint">
                            Obligatorio: el resultado es «{resultadoAtencion}».
                        </p>
                        <SelectorCatalogoConAlta
                            value={motivoNoAvance}
                            onChange={setMotivoNoAvance}
                            opciones={motivosRechazo}
                            placeholder="Escribí para buscar, o un motivo nuevo"
                            onCrear={crearMotivoRechazo}
                        />

                        {motivoNoAvance && motivoNoAvance !== '' && (
                            <Form.Group className="mt-3">
                                <Form.Label className="atn-form-label">Detalle / Observación</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    className="atn-textarea"
                                    value={observacionMotivoNoAvance}
                                    onChange={(e) => setObservacionMotivoNoAvance(e.target.value)}
                                    placeholder="Explique brevemente el motivo"
                                />
                            </Form.Group>
                        )}

                        <div className="mt-3" title="Lo agrega al listado «Volver a contactar» para avisarle por WhatsApp más adelante">
                            <VolverAContactarEnUnRenglon
                                agregar={agregarVolverAContactar}
                                onAgregar={setAgregarVolverAContactar}
                                meses={mesesVolverAContactar}
                                onMeses={setMesesVolverAContactar}
                                idPrefijo="vac-atencion"
                            />
                        </div>
                    </div>
                )}

                {!soloLectura && (
                    <div className="atn-actions">
                        <Button
                            className="atn-btn-primary"
                            onClick={handleFinalizarAtencion}
                            disabled={guardando || cargandoTramites}
                        >
                            {guardando ? (
                                <Spinner animation="border" size="sm" className="me-2" />
                            ) : (
                                <i className="bi bi-check2-circle me-2"></i>
                            )}
                            Finalizar Atención
                        </Button>
                    </div>
                )}

                {soloLectura && renderAccionesFinales()}

                </div>
            </div>
        );
    };

    // Botones de navegación de una ficha ya finalizada: volver al listado, ver el
    // cliente registrado y saltar a los trámites que se le abrieron. Se comparte entre
    // la ficha de mostrador (renderEtapaFicha) y la ficha de acompañamiento ANSES
    // (renderFichaAnsesFinalizada), que hasta ahora no tenía ningún botón.
    const renderAccionesFinales = () => (
        <div className="atn-actions">
            {clienteAtencion && (
                <Button
                    variant="outline-primary"
                    className="atn-btn-secondary"
                    onClick={() => navigate(`/clientes/vista-detallada/${clienteAtencion.cuil}`)}
                >
                    <i className="bi bi-person-fill me-2"></i>
                    Ver Cliente
                </Button>
            )}

            {tramitesCliente && tramitesCliente.length > 0 && (
                tramitesCliente.map((tramite) => {
                    const tipoTramite = normalizarTipoTramite(tramite.tipoTramite);
                    const config = TRAMITES_CONFIG[tipoTramite];
                    // GENERICO no está en TRAMITES_CONFIG porque no se inicia desde el picker
                    // de la atención, pero sí tiene módulo y ruta propia.
                    const esGenerico = tipoTramite === 'GENERICO';
                    // Los demás tipos sin entrada en TRAMITES_CONFIG (tipos nuevos que aún no se
                    // agregaron acá) caen en la ruta legacy /tramites/:id, que redirige al módulo correcto.
                    const ruta = config
                        ? `${config.ruta}/${tramite.idTramite}`
                        : esGenerico
                            ? `/generico/tramites/${tramite.idTramite}`
                            : `/tramites/${tramite.idTramite}`;
                    const nombreBoton = config
                        ? `Ver Trámite ${config.nombreCorto}`
                        : esGenerico
                            ? 'Ver Otro Trámite'
                            : `Ver ${tipoTramite}`;

                    return (
                        <Button
                            key={tramite.idTramite}
                            variant="outline-success"
                            className="atn-btn-secondary"
                            onClick={() => navigate(ruta)}
                        >
                            <i className="bi bi-file-earmark-check me-2"></i>
                            {nombreBoton}
                        </Button>
                    );
                })
            )}

            <Button
                variant="light"
                className="atencion-btn-volver"
                onClick={() => handleSalir()}
            >
                <ArrowBackIcon fontSize="small" className="me-2" />
                {etiquetaVolver}
            </Button>
        </div>
    );

    // Etapa propia de los acompañamientos a ANSES (rediseño 15-oct-2026): no hay atención de
    // mostrador ni checklist; se ve todo lo del turno y hay UN solo botón, "Salió hacia ANSES".
    // Un turno común se cierra ahí (el cliente no vuelve). El de plan de pago queda "En ANSES" hasta
    // que vuelve a abrir el plan ("Volvió de ANSES" en el Panel diario lo manda a la cola).
    const renderEtapaAnses = () => {
        const firmaPendiente = turno.requiereFirma && !turno.firmaResuelta;
        const yaSalio = estadoActual === 'EN_ANSES';
        const presentaciones = turno.presentacionesAnses || [];

        return (
            <div className="atn-shell">
                <div className="atn-card atn-header">
                    <div className="atn-header-top">
                        <div>
                            <h2 className="atn-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <i className="bi bi-building"></i>
                                Turno ANSES
                            </h2>
                            <p className="atn-subtitle">
                                {yaSalio
                                    ? 'Salió hacia ANSES. Vuelve al estudio para abrir el plan de pago.'
                                    : turno.esPlanDePago
                                        ? 'Cuando salga hacia ANSES, el turno queda esperando que vuelva a abrir el plan.'
                                        : 'Cuando salga hacia ANSES, el turno se cierra.'}
                            </p>
                        </div>
                        {turno.esPlanDePago && (
                            <span className="atn-chip atn-chip--success" title="Después de ANSES vuelve al estudio a abrir el plan">
                                <i className="bi bi-cash-coin me-1"></i>Plan de pago
                            </span>
                        )}
                    </div>
                    <div className="atn-header-client">
                        <div className="atn-avatar-circle">
                            {(apellidoNombre(turno.apellido, turno.nombre) || '?').split(/[\s,]+/).filter(Boolean).slice(0, 2).map((x) => x[0]).join('').toUpperCase()}
                        </div>
                        <div className="atn-header-body">
                            <div className="atn-header-name">{apellidoNombre(turno.apellido, turno.nombre)}</div>
                            <div className="atn-header-meta"><span>CUIL {turno.cuilCliente || turno.cuil || turno.dni || 'Sin dato'}</span></div>
                        </div>
                    </div>
                </div>

                <div className="atn-contenido">
                    <div className="atn-card">
                        <div className="atn-field-grid">
                            <CampoDato etiqueta="Citado al estudio" valor={formatearHorario(turno.horario)} />
                            <CampoDato etiqueta="Turno en ANSES" valor={turno.horaTurnoAnses || 'Sin dato'} muted={!turno.horaTurnoAnses} />
                            <CampoDato etiqueta="UDAI / Lugar" valor={turno.udaiLugar || 'No especificado'} muted={!turno.udaiLugar} />
                        </div>

                        {presentaciones.length > 0 && (
                            <>
                                <div className="atn-field-divider" />
                                <h5 className="atn-section-title">Lo que presenta en ANSES</h5>
                                <div className="d-flex flex-wrap gap-2">
                                    {presentaciones.map((p) => (
                                        <span key={p.idPresentacion} className="atn-chip atn-chip--neutral">
                                            <i className="bi bi-file-earmark-text me-1"></i>
                                            {formatearTipoTramite(p.tipoTramite)}
                                            {p.resultado && p.resultado !== 'PENDIENTE' && ` · ${p.resultado.toLowerCase()}`}
                                        </span>
                                    ))}
                                </div>
                            </>
                        )}

                        {turno.requiereFirma && (
                            <>
                                <div className="atn-field-divider" />
                                <h5 className="atn-section-title">Documentación a firmar</h5>
                                <Alert variant={firmaPendiente ? 'warning' : 'success'} className="py-2 mb-0">
                                    <i className={`bi ${firmaPendiente ? 'bi-pencil-square' : 'bi-check-circle-fill'} me-2`}></i>
                                    <strong>{firmaPendiente ? 'Pendiente de firma.' : 'Firmada.'}</strong>
                                    {turno.documentacionAFirmar && <div className="small mt-1">{turno.documentacionAFirmar}</div>}
                                    {firmaPendiente && <div className="small">Antes de que salga se pide confirmar si firmó.</div>}
                                </Alert>
                            </>
                        )}

                        <div className="atn-field-divider" />
                        <Form.Group>
                            <Form.Label className="atn-form-label">Notas</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                className="atn-textarea"
                                value={notas}
                                onChange={(e) => setNotas(e.target.value)}
                                placeholder="Observaciones de la espera..."
                            />
                        </Form.Group>
                    </div>

                    <div className="atn-actions">
                        {!yaSalio ? (
                            <Button className="atn-btn-primary" onClick={handleSalidaAAnses} disabled={guardando}>
                                <i className="bi bi-box-arrow-right me-2"></i>
                                {guardando ? 'Registrando...' : 'Salió hacia ANSES'}
                            </Button>
                        ) : (
                            <>
                                <span className="atn-text-secondary me-auto">
                                    <i className="bi bi-hourglass-split me-1"></i>
                                    Cuando vuelva, marcalo con <strong>Volvió de ANSES</strong> en el Panel diario: pasa a la cola para abrir el plan.
                                </span>
                                <Button variant="outline-secondary" className="atn-btn-secondary" onClick={handleRegresoDeAnses} disabled={guardando}
                                    title="El cliente no volvió al estudio: se cierra el turno sin abrir el plan">
                                    <i className="bi bi-x-circle me-2"></i>
                                    {guardando ? 'Guardando...' : 'No volvió: cerrar turno'}
                                </Button>
                            </>
                        )}
                    </div>

                    <p className="atn-text-secondary" style={{ textAlign: 'center', margin: 0 }}>
                        El resultado de la presentación (si ingresó o lo rechazaron) se registra en el trámite
                        {turno.esPlanDePago ? ' o en la apertura del plan' : ''}, no acá.
                    </p>
                </div>
            </div>
        );
    };

    /**
     * Ficha de un turno ANSES ya cerrado. No es una atención de mostrador, así que no muestra
     * ni el checklist ni la apertura de trámites: lo que importa es que el cliente salió al
     * organismo y qué pasó con la firma. El resultado de la presentación vive en el trámite.
     */
    const renderFichaAnsesFinalizada = () => (
        <div className="atn-shell">
            <div className="atn-card">
                <div className="d-flex align-items-center gap-2" style={{ marginBottom: '14px' }}>
                    <h2 className="atn-title" style={{ fontSize: '16px', display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
                        <i className="bi bi-building"></i>Turno ANSES finalizado
                    </h2>
                    <span className="atn-badge-etapa atn-badge-etapa--success">Finalizado</span>
                </div>

                <div className="atn-field-grid">
                    <CampoDato etiqueta="Cliente" valor={apellidoNombre(turno.apellido, turno.nombre)} />
                    <CampoDato etiqueta="Citado al estudio" valor={formatearHorario(turno.horario)} />
                    <CampoDato etiqueta="Turno en ANSES" valor={turno.horaTurnoAnses || 'Sin turno del organismo'} muted={!turno.horaTurnoAnses} />
                    <CampoDato etiqueta="UDAI / Lugar" valor={turno.udaiLugar || 'No especificada'} muted={!turno.udaiLugar} />
                </div>

                {turno.requiereFirma && (
                    <Alert variant={turno.firmaResuelta ? 'success' : 'warning'} className="py-2 mt-3 mb-0">
                        <i className={`bi ${turno.firmaResuelta ? 'bi-check-circle-fill' : 'bi-exclamation-triangle-fill'} me-2`}></i>
                        {turno.firmaResuelta
                            ? 'Firmó la documentación antes de salir.'
                            : 'Salió con la documentación sin firmar.'}
                        {turno.documentacionAFirmar && <div className="small mt-1"><strong>Documentación:</strong> {turno.documentacionAFirmar}</div>}
                    </Alert>
                )}

                {turno.notasAtencion && (
                    <div className="atn-note-block">
                        <h5 className="atn-section-title">Notas</h5>
                        <p>{turno.notasAtencion}</p>
                    </div>
                )}

                <p className="atn-text-secondary" style={{ marginTop: '14px', marginBottom: 0 }}>
                    El resultado de la presentación (si ingresó, quedó condicional o lo rechazaron) se
                    registra y se consulta en el trámite.
                </p>
            </div>

            {renderAccionesFinales()}
        </div>
    );

    const ComponenteTramiteActivo = tramiteModalTipo ? configTramite(tramiteModalTipo)?.componente : null;

    return (
        <div className="homepage-container area-recepcion">
            {/* Decisión de la firma pendiente: no bloquea la salida, pero obliga a resolverla. */}
            <Modal show={mostrarModalFirma} onHide={() => setMostrarModalFirma(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="bi bi-pencil-square me-2 text-warning"></i>
                        Documentación pendiente de firmar
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Antes de que salga hacia ANSES hay que registrar qué pasó con la
                        documentación que tenía que firmar.
                    </p>
                    <Form.Group>
                        <Form.Label className="fw-semibold">Si sale sin firmar, dejá constancia</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            value={observacionFirma}
                            onChange={(e) => setObservacionFirma(e.target.value)}
                            placeholder="Por ejemplo: falta la firma del cónyuge, se firma al volver..."
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    <Button variant="link" onClick={() => setMostrarModalFirma(false)} disabled={guardando}>
                        Volver
                    </Button>
                    <div className="d-flex gap-2">
                        <Button variant="outline-warning" onClick={() => resolverFirmaYSalir(false)} disabled={guardando}>
                            Sale sin firmar
                        </Button>
                        <Button variant="success" onClick={() => resolverFirmaYSalir(true)} disabled={guardando}>
                            Ya firmó
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <ModalRegistrarCliente
                open={mostrarModalRegistro}
                onClose={() => setMostrarModalRegistro(false)}
                onSuccess={handleRegistroExitoso}
                mostrarDialogoConfirmacion={false}
                datosIniciales={{
                    cuil: turno?.cuil || turno?.dni,
                    nombre: turno?.nombre,
                    apellido: turno?.apellido,
                    telefonoCliente: turno?.telefonoCliente,
                    referencia: turno?.referencia,
                    idReferencia: turno?.idReferencia
                }}
            />

            {/* Vinculación turno↔cliente. Es el mismo componente que usa el modal de detalle
                del turnero: acá se abre desde la cabecera para no repetir el cliente dos veces
                en la ficha. */}
            <Modal show={mostrarModalVinculo} onHide={() => setMostrarModalVinculo(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="bi bi-person-check-fill me-2 text-primary"></i>
                        Cliente del turno
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <VincularClienteTurno
                        turno={turno}
                        onCambio={(actualizado) => {
                            setTurno(actualizado);
                            refrescarCliente();
                            setMostrarModalVinculo(false);
                        }}
                    />
                </Modal.Body>
            </Modal>

            <CustomModal {...modalState} onHide={hideModal} />

            <Dialog
                open={Boolean(tramiteModalTipo)}
                onClose={cerrarModalTramite}
                maxWidth="md"
                fullWidth
                className="dialog-centrado-contenido"
            >
                <IconButton
                    onClick={cerrarModalTramite}
                    sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1, background: 'rgba(255,255,255,0.85)' }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent sx={{ p: 0 }}>
                    {ComponenteTramiteActivo && (
                        <ComponenteTramiteActivo
                            cuilInicial={cuilParaModal}
                            idTurnoOrigen={resolverIdTurno(turno)}
                            onSuccess={(tramiteCreado) => handleTramiteCreado(tramiteModalTipo, tramiteCreado)}
                            onIniciarComplementario={(tramiteCreado) => handleIniciarComplementario(tramiteModalTipo, tramiteCreado)}
                            vieneDeOtroTramite={esComplementario}
                            fechaLiquidarInicial={fechaLiquidarModal}
                            onCancel={cerrarModalTramite}
                        />
                    )}
                </DialogContent>
            </Dialog>

            {toast && (
                <div className={`atencion-mensaje-exito ${toast.tipo === 'error' ? 'atencion-mensaje-error' : ''}`}>
                    <i className={`bi ${toast.tipo === 'error' ? 'bi-exclamation-circle-fill' : 'bi-check-circle-fill'} me-2`}></i>
                    {toast.mensaje}
                </div>
            )}

            <Button
                variant="light"
                className="atencion-btn-volver"
                onClick={() => handleSalir()}
            >
                <ArrowBackIcon fontSize="small" className="me-2" />
                {etiquetaVolver}
            </Button>

            <div className="homepage-header atencion-header">
                <div>
                    <h1 className="homepage-title">
                        <i className="bi bi-person-check-fill me-3"></i>
                        Atención del turno #{turno.numeroIdentificacion || turno.idTurno}
                    </h1>
                    <p className="homepage-subtitle">
                        Seguimiento del ciclo de atención desde Asistió hasta Finalizado.
                    </p>
                </div>
            </div>

            {error && (
                <Alert variant="danger" className="mt-3">
                    {error}
                </Alert>
            )}

            <div>
                {esAperturaPlan ? (
                    <VistaDetalladaAtencionAperturaPlan
                        turno={turno}
                        estadoActual={estadoActual}
                        guardando={guardando}
                        recarga={recargaApertura}
                        onEmpezarAtencion={handleEmpezarAtencion}
                        onError={setError}
                        onFinalizada={() => handleSalir()}
                        onCrearJubilacion={(fecha) => { setFechaLiquidarModal(fecha); abrirModalTramite('JUBILACION'); }}
                    />
                ) : esAcompanamientoAnses ? (
                    <>
                        {(estadoActual === 'ASISTIO' || estadoActual === 'EN_ANSES') && renderEtapaAnses()}
                        {estadoActual === 'FINALIZADO' && renderFichaAnsesFinalizada()}
                    </>
                ) : esAtencionCobro ? (
                    // El turno de cobro tiene pantalla propia: no se atiende como mostrador (no abre
                    // trámites ni lleva checklist), se cobra. Un turno cerrado sin cobro vinculado no
                    // tiene ficha de cobro que mostrar, así que cae en la de mostrador.
                    !puede('cobranzas.cobrar') ? (
                        <Alert variant="warning" className="mt-3">
                            Este turno es de cobro y no tenés permiso para operar cobranzas. Pedile a
                            un administrador que lo atienda.
                        </Alert>
                    ) : estadoActual === 'FINALIZADO' && !turno.idCobro ? (
                        renderEtapaFicha()
                    ) : (
                        <VistaDetalladaAtencionCobro
                            turno={turno}
                            estadoActual={estadoActual}
                            clienteAtencion={clienteAtencion}
                            tramitesCliente={tramitesCliente}
                            notas={notas}
                            setNotas={setNotas}
                            resultadoAtencion={resultadoAtencion}
                            setResultadoAtencion={setResultadoAtencion}
                            resultadosAtencion={resultadosAtencion}
                            guardando={guardando}
                            setGuardando={setGuardando}
                            onEmpezarAtencion={handleEmpezarAtencion}
                            onError={setError}
                            onTurnoActualizado={setTurno}
                            onAbrirVinculoCliente={() => setMostrarModalVinculo(true)}
                            onAbrirTramite={(ruta) => navigate(ruta)}
                            onAtencionFinalizada={() => handleSalir()}
                        />
                    )
                ) : (
                    <>
                        {estadoActual === 'ASISTIO' && renderEtapaDatos()}
                        {(estadoActual === 'EN_CURSO' || estadoActual === 'FINALIZADO') && renderEtapaFicha()}
                    </>
                )}
            </div>
        </div>
    );
};

export default VistaDetalladaAtencion;
